"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLabel = void 0;
const change_case_1 = require("change-case");
/**
 * Guesses a label based on an `id`-ish string, i.e. even an id of
 * `homeownerContractId` will return `Homeowner Contract`.
 *
 * This is primarily useful for our `Bound...` controls where we'll
 * have a known id/key for a given form state field.
 */
function defaultLabel(id) {
    return (0, change_case_1.capitalCase)(id).replace(/Ids?$/, "").trim();
}
exports.defaultLabel = defaultLabel;
